import {
  GET_DOCUMENT_ERROR,
  GET_DOCUMENT_PENDING,
  GET_DOCUMENT_SUCCESS,
  GET_PAGE_ERROR,
  GET_PAGE_PENDING,
  GET_PAGE_SUCCESS,
  GET_TEXT_CONTENT_ERROR,
  GET_TEXT_CONTENT_PENDING,
  GET_TEXT_CONTENT_SUCCESS,
  SCALE_PAGE,
  SET_PAGE_ROTATION,
  APPLY_LEGACY_ROTATIONS,
  SET_SCALE,
} from './constants'
import { getAccessTokenFromAppState } from '../../utils'
const pdfjsLib = require('pdfjs-dist')
const PDFJS = require('pdfjs-dist/build/pdf')

pdfjsLib.GlobalWorkerOptions.workerSrc = '/vendor/pdfjs-dist/pdf.worker.min.js'

export function loadDocument(documentUrl) {
  return (dispatch, getState) => {
    dispatch({ type: GET_DOCUMENT_PENDING })

    PDFJS.getDocument({
      url: documentUrl,
      cMapPacked: true,
      cMapUrl: '/cmaps/',
      httpHeaders: {
        // Note : we can't send an Authorization Bearer token here, because this URL can 302 redirect to S3,
        // and many browsers (Chrome, Edge) pass on Authorization headers even to 3rd party 302 redirects.
        // AWS throws an error if you pass it more than one auth mechanism.  So, our server exchanges
        // this non-standard, non-reserved header for an Authorization Bearer token, allowing S3 redirect to work.
        'file-download-token': `${getAccessTokenFromAppState()}`,
      },
    })
      .promise.then((pdfDocument) => {
        dispatch({ type: GET_DOCUMENT_SUCCESS, documentUrl, pdfDocument })
      })
      .then(() => {
        loadPage(dispatch, getState)
      })
      .catch((error) => {
        console.log('GET_DOCUMENT_ERROR', error)
        dispatch({ type: GET_DOCUMENT_ERROR, error })
      })
  }
}

export function loadPage(dispatch, getState) {
  const { pdfDocument } = getState().document

  if (pdfDocument && pdfDocument.getPage) {
    dispatch({ type: GET_PAGE_PENDING })

    pdfDocument
      .getPage(1)
      .then((page) => {
        dispatch({ type: GET_PAGE_SUCCESS, page })
        loadTextLayer(dispatch, getState)
      })
      .catch((error) => {
        console.log('GET_PAGE_ERROR', error)
        dispatch({ type: GET_PAGE_ERROR, error })
      })
  }
}

export function loadTextLayer(dispatch, getState) {
  dispatch({ type: GET_TEXT_CONTENT_PENDING })
  const { page } = getState().document
  page
    .getTextContent({ normalizeWhitespace: true })
    .then((textContent) => {
      dispatch({ type: GET_TEXT_CONTENT_SUCCESS, textContent })
    })
    .catch((error) => {
      console.log('GET_TEXT_CONTENT_ERROR', error)
      dispatch({ type: GET_TEXT_CONTENT_ERROR, error })
    })
}

export function scalePageByRatio(browserWidth, pageWidth) {
  if (typeof browserWidth !== 'number') {
    throw new Error('expected browserWidth to be a number')
  }
  if (typeof pageWidth !== 'number') {
    throw new Error('expected pageWidth to be a number')
  }
  const scaleRatio = 1 / (pageWidth / browserWidth)
  return (dispatch, getState) => {
    dispatch({ type: SET_SCALE, scaleRatio })
    // TODO: fix loading so loadTextLayer's page is populated via state
    setTimeout(() => {
      loadPage(dispatch, getState)
    }, 15)
  }
}

export function scalePage(scaleModifier) {
  return (dispatch, getState) => {
    dispatch({ type: SCALE_PAGE, scaleModifier })
    loadPage(dispatch, getState)
  }
}

export function rotatePageClockwise(pdfPageNumber) {
  if (typeof pdfPageNumber !== 'number') {
    throw new Error(`expected pdfPageNumber to be a number`)
  }

  const computeClockwiseRotation = (rotation) => {
    return (rotation + 90) % 360
  }

  return (dispatch, getState) => {
    const pdfRotationsByPage = getState().document.pdfRotationsByPage
    if (pdfRotationsByPage[pdfPageNumber] !== undefined) {
      const newRotation = computeClockwiseRotation(pdfRotationsByPage[pdfPageNumber])
      dispatch({
        type: SET_PAGE_ROTATION,
        pdfPageRotation: newRotation,
        pdfPageNumber: pdfPageNumber,
      })
    } else {
      const pdfDocument = getState().document.pdfDocument
      const viewportScale = getState().document.viewport.scale

      if (pdfDocument && pdfDocument.getPage) {
        pdfDocument.getPage(pdfPageNumber + 1).then((pdfPage) => {
          const viewport = pdfPage.getViewport({ scale: viewportScale })
          const newRotation = computeClockwiseRotation(viewport.rotation)
          dispatch({
            type: SET_PAGE_ROTATION,
            pdfPageRotation: newRotation,
            pdfPageNumber: pdfPageNumber,
          })
        })
      }
    }
  }
}

export function applyLegacyRotations(annotationsByPage, legacyRotationsParam = null) {
  return (dispatch) => {
    // Get rotations from parameter or directly from window object
    const legacyRotations = legacyRotationsParam || window.DocViewer?.document?.rotations || {}

    if (Object.keys(legacyRotations).length === 0) {
      return // No legacy rotations to apply
    }

    // Filter rotations to only include pages that have annotations
    const filteredRotations = {}
    Object.keys(legacyRotations).forEach((pageNum) => {
      const pageAnnotations = annotationsByPage[pageNum] || []
      if (pageAnnotations.length > 0) {
        filteredRotations[pageNum] = legacyRotations[pageNum]
      }
    })

    // Apply only the filtered rotations
    dispatch({
      type: APPLY_LEGACY_ROTATIONS,
      pdfRotationsByPage: filteredRotations,
    })
  }
}
